import {
    CREATE_PLAY_CHAT_SUCCESS,
    CREATE_PLAY_CHAT_ERROR,
    CREATE_PLAY_CHAT_REQUEST,
    CREATE_PLAY_CHAT_STREAM,
    CREATE_PLAY_CHAT_STOP_LOADER,
} from '../../Types/user/Types';
import { createPlay_ConversationApi } from '../../Apis/user/ApiConfig';

export const create_play_chat_success = (res) => {
    return {
        type: CREATE_PLAY_CHAT_SUCCESS,
        payload: res,
    };
};
export const create_play_chat_stream = (res) => {
    return {
        type: CREATE_PLAY_CHAT_STREAM,
        payload: res,
    };
};
export const create_play_chat_error = (error) => {
    return {
        type: CREATE_PLAY_CHAT_ERROR,
        error: error,
    };
};
export const create_play_chat_request = (res) => {
    return {
        type: CREATE_PLAY_CHAT_REQUEST,
        payload: res,
    };
};
export const create_play_chat_stop_loader = (res) => {
    return {
        type: CREATE_PLAY_CHAT_STOP_LOADER,
        payload: res,
    };
};

export const create_play_chat_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(create_play_chat_request());
        try {
            createPlay_ConversationApi(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(create_play_chat_success(res?.data));
                            if (data.message != '' && data.message != null) {
                                dispatch(create_play_chat_stream(true));
                            } else {
                                dispatch(create_play_chat_stop_loader(false));
                            }
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_play_chat_error(res));
                        }
                    } else {
                        dispatch(create_play_chat_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(create_play_chat_error('Something Went Wrong!!!'));
                });
        } catch (err) {
            dispatch(create_play_chat_error(err));
        }
    };
};
